import { twMerge } from "tailwind-merge";

import {
  Table,
  TableData,
  TableHead,
  TableHeader,
  Tag,
} from "~/common/components";
import { capitalize } from "~/common/utils";
import { ResponseTheme } from "~/providers/utils/types/patientPreviewTypes";

const THEME_CLASSNAMES = [
  "bg-neutral-5 text-gray-70",
  "bg-primary-200 text-primary-800",
  "bg-complementary-lightblue-200 text-complementary-lightblue-950",
  "bg-complementary-purple-200 text-complementary-purple-950",
  "bg-complementary-magenta-200 text-complementary-magenta-900",
];

export const ResponseThemesTable = ({
  responseThemes,
  filtered = false,
}: {
  responseThemes: ResponseTheme[];
  filtered?: boolean;
}) => {
  const themes = Array.from(
    new Map(
      responseThemes.map(({ question_theme }) => [
        question_theme.id,
        question_theme,
      ]),
    ).values(),
  ).sort((a, b) => a.order - b.order);

  const questionThemesByTheme = Object.groupBy(
    responseThemes,
    ({ question_theme }) => question_theme.code,
  );

  return (
    <Table className="overflow-hidden rounded-md border">
      <TableHead>
        <tr>
          <TableHeader className="text-wrap">
            Area to further explore
          </TableHeader>
          <TableHeader className="w-3/5 text-wrap md:w-1/2">
            Why this appears
          </TableHeader>
        </tr>
      </TableHead>
      <tbody className="bg-white text-sm text-gray-70">
        {themes.map((theme) => {
          const questionThemes = questionThemesByTheme[theme.code]?.filter(
            (qt) => !filtered || qt.triggered,
          );

          if (!questionThemes?.length) return null;

          return (
            <tr key={theme.id}>
              <TableData className="font-medium">
                <Tag
                  className={twMerge(
                    THEME_CLASSNAMES[theme.order] || THEME_CLASSNAMES[0],
                    "py-1 text-center sm:py-0.5 sm:text-left",
                  )}
                >
                  {theme.name}
                </Tag>
              </TableData>
              <TableData className="flex gap-2">
                <ul className="list-disc pl-4">
                  {questionThemes.map((qt) => (
                    <li key={qt.id}>
                      {qt.flow_node.question_text}
                      <span className="text-nowrap"> {"->"} </span>
                      {capitalize(qt.condition_value)}
                    </li>
                  ))}
                </ul>
              </TableData>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
